import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Contato</h2>
        <form action="https://formspree.io/f/xanqvkew" method="POST">
          <label>
            Nome:
            <input type="text" name="name" required />
          </label>
          <label>
            Email:
            <input type="email" name="email" required />
          </label>
          <label>
            Mensagem:
            <textarea name="message" required></textarea>
          </label>
          <button type="submit" className="btn-primary">
            Enviar
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;
